import Reports from '@/components/modules/reports/index';
import Reportsv2 from '@/components/modules/reports/reportV2';

const reports = [
  {
    path: '/reports',
    name: 'reports',
    component: Reports,
    meta: {
      title: 'Reports',
      requiresAuth: true,
    },
  },
  {
    path: '/reportsv2',
    name: 'reportsV2',
    component: Reportsv2,
    meta: {
      title: 'Reports v2',
      requiresAuth: true,
    },
  },
];

export default reports;
